import { ExportFileFormats, CompressionFormat } from '@dev/ee-api/ee-api-models';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { ExportContacts } from '@/components/Contacts/CommonActions/Export';
import { useSelectedEntity, useEntityRuleForFiltration } from '@/components/Contacts/Group/hooks';
import { ShowDialog } from '@/store/dialog/actions';
import { ShowDialogParams } from '@/store/dialog/types';
import { ExportContactsStart } from '@/store/exports/actions';
import { ExportContactsParams } from '@/store/exports/types';
import { ContactTableContext } from '../../context';

export const useExportsContacts = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { selectedEntity, isSelectedEntityAList } = useSelectedEntity();
    const isList = isSelectedEntityAList(selectedEntity);
    const { selectedRows } = useContext(ContactTableContext);
    const { filtrationRuleWithQuery } = useEntityRuleForFiltration();
    const { selectedAll } = useContext(ContactTableContext);

    const exportContacts = (selectedOnly = !selectedAll): void => {
        const exportedData: ExportContactsParams = {
            fileName: isList ? selectedEntity.ListName : selectedEntity.Name,
            fileFormat: ExportFileFormats.Csv,
            compressionFormat: CompressionFormat.Zip,
        };
        if (selectedOnly) {
            exportedData.emails = selectedRows;
        } else {
            exportedData.rule = filtrationRuleWithQuery;
        }

        const params: ShowDialogParams = {
            title: t('export'),
            confirmLabel: t('export'),
            onClickConfirm: (): void => {
                dispatch(ExportContactsStart(exportedData));
            },
            cancelLabel: t('cancel'),
            body: <ExportContacts selected={exportedData} />,
        };

        dispatch(ShowDialog(params));
    };

    return { exportContacts };
};
